import { gql } from '@apollo/client';

export const applyStepOne = gql`
  mutation CreateApplication($createPayload: CandidateStep1Input) {
    createApplication(input: $createPayload) {
      type
      error {
        code
        description
      }
      user_id
      is_vip
      vipPackExpiryDaysLeft
      step_2_form {
        id
        label
        input_type
        value_type
        mandatory
        value_options {
          id
          value
        }
        value_selected {
          id
          value
        }
      }
      products {
        type
        price
        benefits
      }
      recruiter {
        mobile
        error {
          code
          description
        }
        contact_unlock_packs {
          id
          credits
          price
          duration
        }
      }
      task_id
    }
  }
`;

export const getStep2Data = gql`
  mutation GetStep2Details($createPayload: CandidateStep1Input) {
    getStep2Details(input: $createPayload) {
      is_vip
      vipPackExpiryDaysLeft
      step_2_form {
        id
        label
        input_type
        value_type
        mandatory
        value_options {
          id
          value
        }
        value_selected {
          id
          value
        }
      }
      products {
        type
        price
        benefits
      }
    }
  }
`;

export const applyStepTwo = gql`
  mutation UpdateApplication($updatePayload: CandidateStep2Input) {
    updateApplicationDetails(input: $updatePayload) {
      type
      error {
        code
        description
      }
      is_vip
    }
  }
`;

export const getLink = gql`
  mutation Purchase($payLoad: PurchaseInput) {
    getPaymentLink(input: $payLoad) {
      paymentUrl
    }
  }
`;

export const getApplications = gql`
  query GetJobApplicationStatusIds($userDetails: ApplicationsInput) {
    getApplicationsStatusByUser(input: $userDetails)
  }
`;

export const getApplicationsStatus = gql`
  query GetApplicationsInformation($payload: ApplicationInfoInput) {
    getApplicationsInformation(input: $payload) {
      last_applied_date
      applications {
        id
        ad_id
        step
      }
      profile {
        name
        mobile
        email
        city {
          id
          name
        }
        locality {
          id
          name
        }
      }
      quick_apply_applicable
      skip_apply_applicable
    }
  }
`;

export const getRecruiterDetails = gql`
  mutation ViewRecruiterContact($payload: RecruiterInfoInput) {
    viewRecruiterContact(input: $payload) {
      mobile
      products {
        type
        price
        benefits
      }
      contact_unlock_packs {
        id
        credits
        price
        duration
      }
      is_vip
      error {
        code
        description
      }
    }
  }
`;
